import { useMediaQuery } from 'react-responsive';

export const useCustomMediaQuery = () => {
    const isDesktop = useMediaQuery({ minWidth: 769 });
    const isMobile = useMediaQuery({ maxWidth: 768 });
    const isPortfolioChart = useMediaQuery({ minWidth: 1230 });
    return { isDesktop, isMobile, isPortfolioChart };
};